import { render, staticRenderFns } from "./PictureSelect.vue?vue&type=template&id=47bc95b6&scoped=true&"
import script from "./PictureSelect.vue?vue&type=script&lang=js&"
export * from "./PictureSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bc95b6",
  null
  
)

export default component.exports